import axios from "axios";
let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "";
export default {
  state: {
    userProfileData: {},
    personaQuestionsData: {},
    userProfileSettings: {},
    kitsOwned: {},
    checkEpoch: {},
    fetchCourses: {},
    collabData: [],
    userReviews: null,
    followData: null
  },
  getters: {
    getUserProfileData: (state) => state.userProfileData,
    getPersonaQuestionsData: (state) => state.personaQuestionsData,
    getuserProfileSettings: (state) => state.userProfileSettings,
    getKitsOwned: (state) => state.kitsOwned,
    getcheckEpochKey: (state) => state.checkEpoch,
    getFetchRecommended: (state) => state.fetchCourses,
    getFetchCollabProjects: (state) => state.collabData,
    getFetchUserReviews: (state) => state.userReviews,
    getFollowData: (state) => state.followData,
  },
  actions: {
    fetchUserProfile({ commit }) {
      axios.get(`${BASE_URL}/users/profile`).then((response) => {
        commit("setUserProfileData", response.data.data)
      });
    },
    fetchProfileByUserName({ commit }, userName) {
      axios.get(`${BASE_URL}/users/profile/${userName}`).then((response) => {
        commit("setUserProfileData", response.data.data)
      });
    },
    updateProfileDescription({ dispatch }, profileDescription) {
      axios.put(`${BASE_URL}/users/profile/description`, profileDescription).then((response) => {
        dispatch('fetchUserProfile')
      })
    },
    fetchUserProfileSettings({ commit }) {
      axios.get(`${BASE_URL}/users/profile/setting`).then((response) => {
        commit("setUserProfileSettings", response.data.data)
      });
    },
    updateUserProfileSettings({ dispatch }, profileSettings) {
      axios.post(`${BASE_URL}/users/profile/setting`, profileSettings).then((response) => {
        dispatch('fetchUserProfile')
      })
    },
    fetchPersonaQuestions({ commit }) {
      axios.get(`${BASE_URL}/users/persona/quesions`).then((response) => {
        commit("setPersonaQuestion", response.data.data)
      })
    },
    saveUserPersona({ dispatch }, personaPayload) {
      axios.post(`${BASE_URL}/users/persona`, personaPayload).then((response) => {
        dispatch('fetchUserProfile')
      })
    },
    registerProductByProfile({ dispatch }, epochPayload) {
      axios.post(`${BASE_URL}/products/registerByProfile`, epochPayload).then((response) => {
        dispatch('getkitsOwned')
      })
    },
    getkitsOwned({ commit }) {
      axios.get(`${BASE_URL}/products/register`).then((response) => {
        commit("setKitsOwned", response.data.data);
      })
    },
    getkitsOwnedByUserName({ commit }, userName) {
      axios.get(`${BASE_URL}/products/register/${userName}`).then((response) => {
        commit("setKitsOwned", response.data.data);
      })
    },
    fetchEpochKeyCheck({ commit }, epoch) {
      axios.get(`${BASE_URL}/products/register/checkEpoch/${epoch}`).then((response) => {
        if (response.data.status == "success")
          commit("setcheckEpochKey", response.data.data);
        else
          commit("setcheckEpochKey", false);
      })
    },
    fetchRecommendedCourse({ commit }) {
      axios.get(`${BASE_URL}/curriculum/courseData/recommendation`).then((response) => {
        if (response.data.status == "success")
          commit("setFetchRecommended", response.data["data"]);
        else
          commit("setFetchRecommended", false);
      })
    },
    updateParentProfile({ dispatch }, uploadPayload) {
      return new Promise((resolve, reject) => {
        axios.post(`${BASE_URL}/files/uploads/parentProfileImg`, uploadPayload).then((response) => {
          dispatch('fetchUserProfile');
          resolve(response);
        }).catch((error) => {
          reject(error);
        })
      })
    },
    fetchCollabProjects({ commit }) {
      axios.get(`${BASE_URL}/projects/find/myCollabProjects`).then((response) => {
        let sorted_data = null;
        if (response.data.data != null) {
          sorted_data = response.data.data.filter((content) => content.is_deleted != 1 && content.is_approved == 1);
          commit("setFetchCollabProjects", sorted_data);
        }
      })
    },
    fetchCollabProjectsByUsername({ commit }, userName) {
      axios.get(`${BASE_URL}/projects/find/collabProjects/${userName}`).then((response) => {
        let sorted_data = null;
        if (response.data.data != null) {
          sorted_data = response.data.data.filter((content) => content.is_deleted != 1 && content.is_approved == 1);
          commit("setFetchCollabProjects", sorted_data);
        }
      })
    },
    editUserReview({ dispatch }, reviewPayload) {
      return new Promise((resolve, reject) => {
        axios.post(`${BASE_URL}/reviews/profileUser`, reviewPayload).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    fetchUserReviews({ commit }, user_id) {
      axios.get(`${BASE_URL}/reviews/profileUser/${user_id} `).then((response) => {
        commit("setFetchUserReviews", response.data.data);
      })
    },
    fetchFollowData({ commit }) {
      axios.get(`${BASE_URL}/users/follow`).then((response) => {
        commit("setFollowData", response.data.data);
      })
    },
    followUser({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.post(`${BASE_URL}/users/follow`, payload).then(response => {
          dispatch('fetchFollowData');
          dispatch('socialNotify', payload);
          resolve(response)
        }).catch(error => {
          reject(error);
        })
      })
    },
    UnfollowUser({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.put(`${BASE_URL}/users/unfollow`, payload).then(response => {
          dispatch('fetchFollowData');
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    socialNotify({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.post(`${BASE_URL}/notifications/social/`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error)
          });
      })
    },
  },
  mutations: {
    setUserProfileData: (state, userData) => (state.userProfileData = userData),
    setPersonaQuestion: (state, personaData) => (state.personaQuestionsData = personaData),
    setUserProfileSettings: (state, userSettings) => (state.userProfileSettings = userSettings),
    setKitsOwned: (state, kitsData) => (state.kitsOwned = kitsData),
    setcheckEpochKey: (state, epochData) => (state.checkEpoch = epochData),
    setFetchRecommended: (state, courseData) => (state.fetchCourses = courseData),
    setFetchCollabProjects: (state, collabData) => (state.collabData = collabData),
    setFetchUserReviews: (state, userReviews) => (state.userReviews = userReviews),
    setFollowData: (state, followData) => (state.followData = followData),
  },
};
